// src/pages/subscription/components/PaymentMethodSelector.jsx
import React from 'react';
import { Building2, CreditCard } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './PaymentMethodSelector.module.css';

const PaymentMethodSelector = ({ selectedMethod, onChange, disabled = false }) => {
  const { t } = useLocalization();

  const paymentMethods = [
    {
      id: 'bank_transfer',
      name: t('subscription.payment.bankTransfer'),
      description: t('subscription.payment.bankTransferDesc'),
      icon: Building2,
      popular: false
    },
    {
      id: 'card_payment',
      name: t('subscription.payment.cardPayment'),
      description: t('subscription.payment.cardPaymentDesc'),
      icon: CreditCard,
      popular: true
    }
  ];

  const handleMethodClick = (methodId) => {
    if (!disabled) {
      onChange(methodId);
    }
  };

  return (
    <div className={styles.paymentMethodSelector}>
      <h3 className={styles.title}>{t('subscription.payment.selectPaymentMethod')}</h3>
      <p className={styles.subtitle}>{t('subscription.payment.choosePreferredMethod')}</p>

      <div className={styles.methodsGrid}>
        {paymentMethods.map((method) => {
          const Icon = method.icon;
          const isSelected = selectedMethod === method.id;

          return (
            <div
              key={method.id}
              className={`${styles.methodCard} ${isSelected ? styles.selected : ''} ${disabled ? styles.disabled : ''}`}
              onClick={() => handleMethodClick(method.id)}
              role="button"
              tabIndex={disabled ? -1 : 0}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleMethodClick(method.id);
                }
              }}
            >
              {method.popular && (
                <div className={styles.popularBadge}>
                  {t('subscription.payment.popular')}
                </div>
              )}

              <div className={styles.radioButton}>
                <div className={`${styles.radioOuter} ${isSelected ? styles.radioSelected : ''}`}>
                  {isSelected && <div className={styles.radioInner} />}
                </div>
              </div>

              <div className={styles.iconWrapper}>
                <Icon size={32} className={styles.methodIcon} />
              </div>

              <div className={styles.methodInfo}>
                <h4 className={styles.methodName}>{method.name}</h4>
                <p className={styles.methodDescription}>{method.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentMethodSelector;